import {
    Component,
    TemplateRef,
    ViewContainerRef,
    ViewChild,
} from '@angular/core';
import { SiteServices } from '../../services/siteservices';
import { ProviderContext, Providers } from '../../data/Entities';

import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
    selector: 'categoryproviderapp',
    templateUrl: '/templates/get/CategoryProvider/categoryprovider',
})
export class CategoryProviderComponent {
    current_row: any;
    dtx: ProviderContext;
    providersDtx: ProviderContext;
    rows: any = [];
    filteredRows: Array<any> = [];

    public filter: any = {};
    public Providers = Providers;
    public modalRef: BsModalRef;
    public errstr = '';
    public rootList: Array<any>;
    public sourceList: Array<any> = [];
    public allSelected: boolean;
    public providerList: any;
    public SelectedProviderID: number;
    public SelectedProviderName: string;

    constructor(
        public siteServices: SiteServices,
        private modalService: BsModalService,
        public viewRef: ViewContainerRef
    ) {
        this.dtx = new ProviderContext({
            ProviderCode: 'CATEGORYPROVIDER',
        });

        this.providersDtx = new ProviderContext({ ProviderCode: 'PROVIDER', SortField: 'ProviderName' });
        this.providersDtx.addFilter('Available', 'true');

        this.siteServices.provider_Execute(
            'CATEGORY',
            'GETROOTCATEGORYLIST',
            {},
            (data) => {
                this.rootList = data.TagObject;
            }
        );

        this.siteServices.provider_GetAll(
            this.providersDtx,
            (data) => {
                this.providerList = data.TagObject;
            }
        );

        this.siteServices.provider_GetAll(this.dtx, (data) => {
            this.rows = data.TagObject;
            // would be default sort
            // this.dtx.SortField = "UserID";
            // this.dtx.IsAsc = true;
            // thisRefresh();
            this.filteredRows = data.TagObject;
            this.filteredRows.forEach((x) => {
                //console.log(x.CategoryProviderUrl);
                switch (x.ProviderName) {
                    case 'Tesco':
                        x.CategoryProviderUrl =
                            'https://bevasarlas.tesco.hu/groceries/hu-HU/shop' +
                            x.CategoryProviderUrl;
                        break;
                    case 'Auchan':
                        x.CategoryProviderUrl =
                            'https://online.auchan.hu' + x.CategoryProviderUrl;
                        break;
                    case 'Prima':
                        x.CategoryProviderUrl =
                            'https://online.prima.hu' + x.CategoryProviderUrl;
                        break;
                    case 'GRoby':
                        x.CategoryProviderUrl =
                            'https://www.groby.hu/termekek' +
                            x.CategoryProviderUrl;
                        break;
                    case 'Kellys':
                        x.CategoryProviderUrl =
                            'https://www.groby.hu/termekek' +
                            x.CategoryProviderUrl;
                        break;
                    case 'Hellas':
                        x.CategoryProviderUrl =
                            'https://www.groby.hu/termekek' +
                            x.CategoryProviderUrl;
                        break;
                    case 'Real':
                        x.CategoryProviderUrl = 'https://www.agar.io';
                        break;
                    case 'LacsiBoltja':
                        x.CategoryProviderUrl =
                            'https://www.lacsiboltja.hu' +
                            x.CategoryProviderUrl;
                        break;
                    case 'Aldi':
                        x.CategoryProviderUrl = 'https://www.aldi.hu';
                        break;
                }
            });
            // this.refresh();
        });

        this.modalService.onHide.subscribe((reason: string) => {
            if (this.sourceList.length === 1) {
                this.sourceList[0].checked = false;
                this.sourceList = [];
            }
        });
    }

    refresh() {
        const regexp = new RegExp(this.filter.SearchTerm, 'i');

        const chk = (t, fieldname) => {
            if (t[fieldname] && t[fieldname].search(regexp) >= 0) {
                return true;
            } else {
                return false;
            }
        };

        this.filteredRows = this.rows.filter((row) => {
            if (
                this.filter.ProviderID &&
                this.filter.ProviderID !== row.ProviderID
            ) {
                return false;
            }
            if (this.filter.SearchTerm && this.filter.SearchTerm.length > 1) {
                if (
                    chk(row, 'CategoryProviderName') ||
                    chk(row, 'CategoryProviderUrl') ||
                    chk(row, 'CategoryName')
                ) {
                } else {
                    return false;
                }
            }

            if (this.filter.NotMatched) {
                if (row.CategoryName) {
                    return false;
                }
            }

            return true;
        });

        this.filteredRows = this.siteServices.sort(
            this.filteredRows,
            this.filter,
            this.dtx.SortField,
            this.dtx.IsAsc
        );
    }

    setProvider(prov: Providers, providerName: string = '') {
        console.log(prov);
        this.SelectedProviderID = prov;
        this.SelectedProviderName = providerName;
        this.filter.ProviderID = prov;
        this.refresh();
    }

    onSort(_sortField) {
        if (this.dtx.SortField === _sortField) {
            this.dtx.IsAsc = !this.dtx.IsAsc;
        } else {
            this.dtx.SortField = _sortField;
            this.dtx.IsAsc = true;
        }
        this.refresh();
    }

    public _showModal(template: TemplateRef<any>) {
        this.modalRef = this.modalService.show(template, { class: 'modal-lg' });
    }

    public openModal(template: TemplateRef<any>, sourceCat: any) {
        this.sourceList = [];
        this.sourceList.push(sourceCat);
        this._showModal(template);
    }

    public openModalGroup(template: TemplateRef<any>) {
        this._showModal(template);
    }

    public doBind(weshopCat: any) {
        this.siteServices.provider_Execute(
            'CATEGORYPROVIDER',
            'BINDWESHOPCATEGORY',
            {
                sourceListCID: this.sourceList.map((c) => c.CategoryProviderID),
                weshopCID: weshopCat.CategoryID,
            },
            (data) => {
                this.modalRef.hide();
                this.sourceList.forEach((c) => {
                    c.CategoryName = weshopCat.CategoryName;
                    c.checked = false;
                });
                this.sourceList = [];
                this.siteServices.success('Hozzárendelés OK');
                this.allSelected = false;
            }
        );
    }

    // modal
    public onOpenClose(category: any) {
        if (!category.ChildList || category.ChildList.length === 0) {
            this.siteServices.provider_Execute(
                'CATEGORY',
                'GETCATEGORYBYID',
                { CategoryID: category.CategoryID },
                (data) => {
                    Object.assign(category, data);
                    category.ChildList = data.TagObject.ChildList;
                }
            );
        }
    }

    public clearSearchTerm() {
        this.filter.SearchTerm = '';
        this.refresh();
    }

    public chkAll(ev) {
        if (ev.target.checked) {
            this.sourceList = [];
            this.filteredRows.forEach((x) => {
                x.checked = true;
                this.sourceList.push(x);
            });
        } else {
            this.filteredRows.forEach((x) => {
                x.checked = false;
            });
            this.sourceList = [];
        }
    }

    public chk(ev, catprov) {
        if (ev.target.checked) {
            this.sourceList.push(catprov);
        } else {
            const ndx = this.sourceList.findIndex(
                (x) => x.CategoryProviderID === catprov.CategoryProviderID
            );
            if (ndx >= 0) {
                this.sourceList.splice(ndx, 1);
            }
        }
    }
}
